import { render, staticRenderFns } from "./FactorialMaterialExportList.vue?vue&type=template&id=12b5facd&scoped=true&"
import script from "./FactorialMaterialExportList.vue?vue&type=script&lang=js&"
export * from "./FactorialMaterialExportList.vue?vue&type=script&lang=js&"
import style0 from "./FactorialMaterialExportList.vue?vue&type=style&index=0&id=12b5facd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5facd",
  null
  
)

component.options.__file = "FactorialMaterialExportList.vue"
export default component.exports